import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styles from './RailPanel.module.css';

// Frame of a rail panel (Figma `16776:47200`): title + close, then the content. Same header as the
// Protocol panel; the width comes from where it is shown (next to the rail or over the content).
function RailPanel({ title, closeLabel, onClose, children }) {
    return (
        <section className={styles['rail-panel']} aria-label={title}>
            <header className={styles['rail-panel__header']}>
                <h2 className={styles['rail-panel__title']}>{title}</h2>
                <IconButton className={styles['rail-panel__close']} size="small" aria-label={closeLabel} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </header>
            <div className={styles['rail-panel__body']}>{children}</div>
        </section>
    );
}

RailPanel.propTypes = {
    title: PropTypes.string.isRequired,
    closeLabel: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default RailPanel;
